import port800 from "@/assets/photos/port-800.webp";
import port1400 from "@/assets/photos/port-1400.webp";
import port1920 from "@/assets/photos/port-1920.webp";
import coffee800 from "@/assets/photos/coffee-800.webp";
import coffee1400 from "@/assets/photos/coffee-1400.webp";
import coffee1920 from "@/assets/photos/coffee-1920.webp";
import pepper800 from "@/assets/photos/pepper-800.webp";
import pepper1400 from "@/assets/photos/pepper-1400.webp";
import pepper1920 from "@/assets/photos/pepper-1920.webp";
import nuts800 from "@/assets/photos/nuts-800.webp";
import nuts1400 from "@/assets/photos/nuts-1400.webp";
import nuts1920 from "@/assets/photos/nuts-1920.webp";
import soybean from "@/assets/aleph-soybean-field.webp.asset.json";
import animal800 from "@/assets/aleph-animal-800.webp.asset.json";
import animal1400 from "@/assets/aleph-animal-1400.webp.asset.json";
import animal1920 from "@/assets/aleph-animal-1920.webp.asset.json";
import commodities800 from "@/assets/aleph-commodities-800.webp.asset.json";
import commodities1400 from "@/assets/aleph-commodities-1400.webp.asset.json";
import commodities1920 from "@/assets/aleph-commodities-1920.webp.asset.json";

export type PhotoKey = "port" | "coffee" | "pepper" | "nuts" | "soybean" | "animal" | "commodities";

export type Photo = { src: string; srcSet: string; width: number; height: number };

const build = (small: string, medium: string, large: string, height: number): Photo => ({
  src: medium,
  srcSet: `${small} 800w, ${medium} 1400w, ${large} 1920w`,
  width: 1920,
  height,
});

export const photos: Record<PhotoKey, Photo> = {
  port: build(port800, port1400, port1920, 1280),
  coffee: build(coffee800, coffee1400, coffee1920, 1281),
  pepper: build(pepper800, pepper1400, pepper1920, 1280),
  nuts: build(nuts800, nuts1400, nuts1920, 1280),
  soybean: { src: soybean.url, srcSet: `${soybean.url} 1333w`, width: 1333, height: 1000 },
  animal: build(animal800.url, animal1400.url, animal1920.url, 1080),
  commodities: build(commodities800.url, commodities1400.url, commodities1920.url, 1080),
};

export const photo = (key: string): Photo => photos[key as PhotoKey] ?? photos.port;
